import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";

import { transition } from "../../utils/transition";
import { carouselStyle } from "../Carousel/Carousel.css";
import { gridStyle } from "../Grid/Grid.css";
import { theme } from "../../theme/css/theme.css";

export const addCardStyle = recipe({
  base: {
    minHeight: rem(148),
    selectors: {
      [`${carouselStyle} &`]: {
        width: rem(280),
      },
      [`${gridStyle} &`]: {
        gridColumn: "span 1",
        width: "100%",
      },
    },
  },
  variants: {
    disabled: {
      false: {
        ":hover": {
          color: theme.colors.onBackground,
        },
      },
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export const childrenStyle = style({
  width: "100%",
  flexGrow: 1,
});

export const contentStyle = style({
  alignItems: "center",
  justifyContent: "center",
});

export const iconButtonStyle = style({
  pointerEvents: "none",
});

export const titleStyle = recipe({
  variants: {
    hasHover: {
      true: {
        color: theme.colors.primary,
      },
    },
  },
});

export const textContainerStyle = recipe({
  base: {
    opacity: 1,
    transition: transition("opacity"),
  },
  variants: {
    isOpen: {
      true: {
        opacity: 0,
        pointerEvents: "none",
      },
    },
  },
});

export const clickableCardStyle = style({
  cursor: "pointer",
});
